import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  CircularProgress,
} from '@mui/material';
import { DialogTitleWithClose } from '../../common';

/**
 * NewVersionDialog Component
 * Dialog for creating a new template version
 */
const NewVersionDialog = ({ open, onClose, onSubmit, loading }) => {
  const [formData, setFormData] = useState({
    template: '',
    description: '',
  });

  const handleSubmit = async () => {
    const success = await onSubmit(formData);
    if (success) {
      setFormData({ template: '', description: '' });
      onClose();
    }
  };

  const handleClose = () => {
    setFormData({ template: '', description: '' });
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitleWithClose
        title="Create New Version"
        onClose={handleClose}
        disableClose={loading}
      />
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid size={{ xs: 12 }}>
            <TextField
              fullWidth
              label="Template Content"
              value={formData.template}
              onChange={e =>
                setFormData({
                  ...formData,
                  template: e.target.value,
                })
              }
              multiline
              rows={6}
              placeholder="Enter the new template content..."
              required
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <TextField
              fullWidth
              label="Description"
              value={formData.description}
              onChange={e =>
                setFormData({
                  ...formData,
                  description: e.target.value,
                })
              }
              multiline
              rows={3}
              placeholder="Describe what changed in this version..."
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!formData.template.trim() || loading}
        >
          {loading ? <CircularProgress size={20} /> : 'Create Version'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewVersionDialog;
